<div class="reference_body">
  <main class=" container">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="reference_table">

      <div class="gmou">
        <div class="the_header_monitor">
          <div class="row">
            <div class="col-md-6">
              <h3 class="header">Monitor Project</h3>
            </div>
            <div class="col-md-6">
              <div class="filter_button pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" routerLink="/project"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary"  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>
        </div>

        <div class="monitor_project_drop">

            <!-- <div class="project_input">
              <p style="color:rgb(46, 206, 255); font-size:3rem; margin: 2rem 1rem; font-weight:500;">Filter projects</p>
             <form [formGroup]="selectOptionForm">
              <div class="gmou_input">
                <label for="" style="display:block;">Project category</label>
                <mat-form-field class="full-width-fields" >
                  <mat-select (selectionChange)="selectProjectType($event)" formControlName="GMOUTypeId">
                    <mat-option>-- None --</mat-option>
                    <mat-optgroup *ngFor="let projectCategory of projectCategories" [label]="projectCategory.ProjectCategoryName"
                                  >
                      <mat-option *ngFor="let projectType of projectCategory.projectTypes" [value]="projectType.id">
                        {{projectType.ProjectTypeName}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
            </div>
            <div class="gmou_input">
                <label for="" style="display:block;">GMOU Name</label>
                <mat-form-field class="full-width-fields" >
                  <mat-select (selectionChange)="selectGMOU($event.value)" formControlName="GMOUId">
                    <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let gmou of selectedGmous" [value]="gmou.id">
                        {{gmou.GMOUTitle}}
                      </mat-option>

                  </mat-select>
                </mat-form-field>
            </div>

            <div class="gmou_input">
              <label for="" style="display:block;">Project Name</label>
              <mat-form-field class="full-width-fields" >
                <mat-select (selectionChange)="selectProject($event.value)" formControlName="ProjectId">
                  <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let project of selectedProject" [value]="project.id">
                      {{project.ProjectTitle}}
                    </mat-option>

                </mat-select>
              </mat-form-field>
          </div>
             </form>

            </div> -->

           <!-- <form [formGroup]="projectForm"> -->
            <div class="other_details" *ngIf="status" [@fadeInAnimation]>
              <div class="the_card the__detail-card">
                <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">State</span>
                      <span class="the__input" *ngFor="let data of ProjectData?.States">
                        {{data?.StateName}}
                      </span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">LGA</span>
                      <span class="the__input" *ngFor="let data of ProjectData?.Lgas">
                     {{data?.LgaName}}
                      </span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                      <div class="the__input" *ngFor="let oilBlock of ProjectData?.OilBlocks">
                      {{oilBlock?.OilBlockName}}
                      </div>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                      <div class="the__input" *ngFor="let oilField of ProjectData?.OilFields">
                        {{oilField?.OilFieldName}}
                      </div>
                  </h4>
              </div>
              </div>

              <h4 class="description">
                <span class="label">Project description</span>
                <span class="described">{{ProjectData?.Description}}</span>
            </h4>

            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">Project executor</span>
                    <span class="the_input">{{ProjectData?.Executor}}</span>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">Start date</span>
                    <span class="the_input">{{ProjectData?.StartDate | date}}</span>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">End date</span>
                    <span class="the_input">{{ProjectData?.EndDate | date}}</span>
                </h4>
            </div>
            <div class="detail__info">
                <h4 class="label">
                    <span class="labels" style="display: block;">Budget</span>
                    <span class="the_input">{{ProjectData?.Budget | currency:'NGN':'symbol-narrow'}}</span>
                </h4>
            </div>
              <!-- <pre>{{projectManagements | json}}</pre> -->

              <!-- <div class="container" style="text-align: center; width:100%;">
                  <button class="top__button mt-5" type="submit" (click)="onSubmit(projectForm.value)" [disabled]="projectForm.invalid" >Submit</button>
              </div> -->
          </div>



        </div>





     <div class="" *ngIf="status">
      <div class="row">
      <h3 class="other_project"> Other Project Information</h3>

        <div class="col-md-12">
          <div class="the__table mt-5" >
            <mat-tab-group color="accent" >
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">payment</mat-icon>
                   Payments
                </ng-template>
<!-- <pre>{{bankDetails | json}}</pre> -->
                <div class="reference_table" style="margin-top: 0rem;">
                  <div class="" style="text-align: right; width:95%;">
                    <button mat-raised-button color="primary" class="mr-3 mt-3" (click)="saveProjectPayment()">Save
                          payment <em class="ti-plus"></em> </button>

                          <button mat-raised-button  class="mt-3"  (click)="openCreatePaymentModal()">Add
                            payment <em class="ti-plus"></em> </button>
                  </div>
                  <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->

                  <div class="table payroll-table">
                      <div class="thead payroll">
                          <span class="head">S/N</span>
                          <span class="head">Amount</span>
                          <span class="head">Invoice No.</span>
                          <span class="head">Payment Date</span>
                          <span class="head">Description</span>
                      </div>

                      <div class="tbody">
                          <div class="td  payroll" *ngFor="let payment of monitorProjectPaymentForm.get('MonitorProjectPayments')['controls']; index as i">
                              <span class="head">{{i + 1}}</span>
                              <Span class="head" *ngIf="payment.value.CurrencyId">{{payment.value.Amount | currency:getCurrencyName(payment.value.CurrencyId):'symbol-narrow'}}</Span>
                              <Span class="head">{{payment.value.InvoiceNo}}</Span>
                              <Span class="head">{{payment.value.PaymentDate | date}}</Span>
                              <Span class="head">{{payment.value.PaymentDescription}}</Span>
                          </div>
                      </div>
                      <div class="total__amount">
                          <span class="word pr-3">Total Amount:</span>
                          <span class="main__amount">{{totalAmountPaid | currency:'NGN':'symbol-narrow'}}</span>
                      </div>
                      <!-- <div class="submit">
                          <button class="submit_button">Submit</button>
                      </div> -->
                  </div>
              </div>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label >
                  <mat-icon class="example-tab-icon">supervised_user_circle</mat-icon>
               Stakeholders
                </ng-template>
                <div class="page_content">
                  <div class="row">
                  <div class="col-md-12">
                    <div class="search_stakeholder scholarship_search">
                      <input type="search" name="search" id="nav_search search" [value]="searchStakeholderValue" (keyup)="search($event.target.value)"  placeholder="Search for Stakeholder Name">
                      <span class="search_icon"><img src="assets/images/top_nav/Magnifiction.svg" alt=""
                              class="magnify"></span>
                  </div>
                  </div>


                      <!-- <span><mat-checkbox class=" mr-5" (change)="OnChange($event)"></mat-checkbox></span> -->



                  </div>

                 <div class="row">
                   <div class=" col-md-12">

                    <div class="scholarship_search_result edit cursor" *ngFor="let stakeholder of searchedStakeholders" >

                      <div class="info" (click)="addStakeholder(stakeholder)" style="cursor: pointer;">

                          <h5>
                              <span class="label">Name</span>
                              <span class="Answer">{{stakeholder.StakeholderName}}</span>
                          </h5>

                          <h5>
                              <span class="label">Type</span>
                              <span class="Answer">{{stakeholder.StakeholderTypeName}}</span>
                          </h5>

                          <h5>
                              <span class="label">Role</span>
                              <span class="Answer">{{stakeholder.StakeholderRole}}</span>
                          </h5>

                          <h5>
                              <span class="label">Address</span>
                              <span class="Answer">{{stakeholder.StakeholderAddress}}</span>
                          </h5>

                      </div>
                  </div>
                   </div>
                 </div>



              </div>

                <div class="reference_table" style="margin-top: 0rem;">
                  <!-- <div class="" style="text-align: right; width:95%;" ><button class="top_button" >Save<em class="ti-plus"></em> </button>
                  </div> -->
                  <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->
<!-- <pre>{{projectClusters | json}}</pre> -->
                  <div class="the_edited" #stake>
                      <div class="thead">
                          <span class="head">S/N</span>
                          <span class="head">Name</span>
                          <span class="head">Type</span>
                          <span class="head">Role</span>
                          <span class="head">Address</span>
                          <span class="head">Action</span>
                      </div>

                      <div class="tbody">
                          <div class="td" *ngFor="let stakeholder of moitorProjectForm.get('MonitorProjects')['controls']; index as i" >
                              <span class="head">{{i + 1}}</span>
                              <Span class="head">{{stakeholder.value.StakeholderName}}</Span>
                              <Span class="head">{{stakeholder.value.StakeholderTypeName}}</Span>
                              <Span class="head">{{stakeholder.value.StakeholderRole}}</Span>
                              <Span class="head">{{stakeholder.value.StakeholderAddress}}</Span>
                              <span
                              ><button
                                class="delete_icon trash"
                                (click)="deleteProjectStakeholder(i,stakeholder.value)"
                              >
                                <em class="ti-trash"> </em> </button
                            ></span>
                          </div>
                      </div>

                      <div class="submit">

                        <button type="submit"   class="submit_button" type="submit" (click)="saveStakeholder()" *ngIf="isAddStakeholder">Submit</button>


                       </div>

                  </div>
              </div>
              </mat-tab>

              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">folder</mat-icon>
                  Documents
                </ng-template>

                Documents Content
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">location_on</mat-icon>
                  Clusters
                </ng-template>

                <div class="page_content">
                  <div class="row">
                  <div class="col-md-12">
                    <div class="search scholarship_search">
                      <input type="search" name="search" id="nav_search search" [value]="searchClusterValue" (keyup)="searchCluster($event.target.value)"  placeholder="Search for Cluster Name">
                      <span class="search_icon"><img src="assets/images/top_nav/Magnifiction.svg" alt=""
                              class="magnify"></span>
                  </div>
                  </div>


                      <!-- <span><mat-checkbox class=" mr-5" (change)="OnChange($event)"></mat-checkbox></span> -->



                  </div>

                 <div class="row">
                   <div class=" col-md-12">

                    <div class="scholarship_search_result edit cursor" *ngFor="let cluster of searchedClusters" >

                      <div class="info" (click)="addCluster(cluster)" style="cursor: pointer;">

                          <h5>
                              <span class="label">Name</span>
                              <span class="Answer">{{cluster.ClusterName}}</span>
                          </h5>


                      </div>
                  </div>
                   </div>
                 </div>



              </div>

                <div class="reference_table" style="margin-top: 0rem;">
                  <!-- <div class="" style="text-align: right; width:95%;" ><button class="top_button" >Save<em class="ti-plus"></em> </button>
                  </div> -->
                  <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->

                  <div class="the_edited_cluster" #stake>
                      <div class="thead">
                          <span class="head">S/N</span>
                          <span class="head">Name</span>
                          <span class="head">Action</span>
                      </div>

                      <div class="tbody">
                          <div class="td" *ngFor="let cluster of monitorProjectClusterForm.get('MonitorProjectClusters')['controls']; index as i" >
                              <span class="head">{{i + 1}}</span>
                              <Span class="head">{{cluster.value.ClusterName}}</Span>

                              <span
                              ><button
                                class="delete_icon trash"
                                (click)="deleteProjectCluster(i,cluster.value)"
                              >
                                <em class="ti-trash"> </em> </button
                            ></span>
                          </div>
                      </div>

                      <div class="submit">

                        <button type="submit"   class="submit_button" type="submit" (click)="saveCluster()" *ngIf="isAddCluster">Submit</button>


                       </div>

                  </div>
              </div>
              </mat-tab>
            </mat-tab-group>

        </div>

        </div>
      </div>
     </div>

        <!-- <div class="container"
            style="text-align:right; width:95%; margin-top: 3rem; padding-left: 3rem; border-top:1px solid rgb(192, 192, 192);" *ngIf="status">
            <button class="new__activity mt-5" (click)="openCreateActivityModal()">Create activity</button>
        </div> -->



    </div>
</div>
      </div>

  </main>
</div>
